/* ============================================
   Block : Dossier · Autres dossiers — flèches du rail
   - Affiche les flèches précédent / suivant quand le rail déborde.
   - Un clic fait défiler d'une « page » de cartes ; les flèches se désactivent en bout de rail.
   Sans JS, le rail reste défilable nativement (tactile, trackpad, clavier).
   ============================================ */

(function () {
  'use strict';

  var EDGE_TOLERANCE = 2; // px : arrondis de scrollLeft

  function initRelated(root) {
    if (root.hasAttribute('data-fdos-related-init')) return;
    root.setAttribute('data-fdos-related-init', '');

    var list = root.querySelector('[data-fdos-related-list]');
    var nav = root.querySelector('[data-fdos-related-nav]');
    var prev = root.querySelector('[data-fdos-related-prev]');
    var next = root.querySelector('[data-fdos-related-next]');
    if (!list || !nav || !prev || !next) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function update() {
      ticking = false;
      var max = list.scrollWidth - list.clientWidth;
      nav.hidden = max <= EDGE_TOLERANCE;
      prev.disabled = list.scrollLeft <= EDGE_TOLERANCE;
      next.disabled = list.scrollLeft >= max - EDGE_TOLERANCE;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function scrollByPage(direction) {
      var gap = parseFloat(window.getComputedStyle(list).columnGap) || 0;
      list.scrollBy({
        left: direction * (list.clientWidth + gap),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { scrollByPage(-1); });
    next.addEventListener('click', function () { scrollByPage(1); });
    list.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fdos-related]');
    Array.prototype.forEach.call(roots, initRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
